import { COUPON_TYPE } from '../enums/couponType';

export default interface CouponModel {
  id: number;
  code: string;
  name: string;
  description?: string;
  type: typeof COUPON_TYPE.PERCENT | typeof COUPON_TYPE.FIXED | typeof COUPON_TYPE.FREE_SHIPPING;
  discount_value: number;
  min_order_amount?: number;
  applies_to: 'all' | 'categories' | 'products';
  category_ids?: number[];
  product_ids?: number[];
  start_date?: string;
  end_date?: string;
  max_redemptions?: number;
  max_uses_per_customer?: number;
  current_redemptions: number;
  remaining_redemptions?: number;
  is_active: boolean;
  is_expired: boolean;
  is_not_started: boolean;
  created_at: string;
  updated_at: string;
}

export const deriveRawToCoupon = (raw): CouponModel => {
  return {
    id: raw.id,
    code: raw.code,
    name: raw.name,
    description: raw.description,
    type: raw.type,
    discount_value: Number(raw.discount_value),
    min_order_amount: raw.min_order_amount ? Number(raw.min_order_amount) : undefined,
    applies_to: raw.applies_to,
    category_ids: raw.category_ids || [],
    product_ids: raw.product_ids || [],
    start_date: raw.start_date,
    end_date: raw.end_date,
    max_redemptions: raw.max_redemptions,
    max_uses_per_customer: raw.max_uses_per_customer,
    current_redemptions: raw.current_redemptions || 0,
    remaining_redemptions: raw.remaining_redemptions,
    is_active: !!raw.is_active,
    is_expired: !!raw.is_expired,
    is_not_started: !!raw.is_not_started,
    created_at: raw.created_at,
    updated_at: raw.updated_at,
  };
};

export const initialCoupon: CouponModel = {
  id: 0,
  code: '',
  name: '',
  description: '',
  type: COUPON_TYPE.FIXED,
  discount_value: 0,
  applies_to: 'all',
  current_redemptions: 0,
  is_active: true,
  is_expired: false,
  is_not_started: false,
  created_at: '',
  updated_at: '',
};
